import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd0060-container" }
const _hoisted_2 = { class: "cmd0060-conditions-form" }
const _hoisted_3 = { class: "row q-gutter-x-md" }
const _hoisted_4 = {
  class: "col",
  style: {"max-width":"450px"}
}
const _hoisted_5 = {
  id: "sketch-iframe",
  ref: "sketch-iframe",
  "data-toolbars": "reporting",
  title: "marvin js editor",
  src: "../../sketch/editorws.html",
  style: {"overflow":"hidden","width":"100%","height":"100% min-width: 500px","min-height":"350px","border":"1px solid darkgray"}
}
const _hoisted_6 = { class: "column row align-end justify-between attoid-input-area" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row q-gutter-x-xs flex justify-end" }
const _hoisted_9 = { class: "full-width row q-gutter-sm" }
const _hoisted_10 = { class: "q-pt-xs" }
const _hoisted_11 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex items-start" }
const _hoisted_14 = { class: "q-mb-none" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import SearchOpenCloseButton from '../../components/button/SearchOpenCloseButton.vue';
import AtomImage from '../../components/images/AtomImage.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import { clearMarvin, getMarvin } from '../../common/marvin-js';
import messages from '../../messages/message.json';

// 検索結果
interface Result {
  atto_id: string;
  structure: string;
  reg_group_name: string;
  reg_structure_name: string;
  reg_category_name: string;
  reg_error: string;
  excluded_flag: string;
  create_user_name: string;
  create_timestamp: string;
}

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00600',
  setup(__props) {

const columns: Array<any> = [
  {
    name: 'delete',
  },
  {
    name: 'atto_id',
    label: 'ATTO_ID',
    align: 'left',
    field: 'atto_id',
    style: 'width: 100px',
    sortable: true,
  },
  {
    name: 'structure',
    label: '構造',
    align: 'left',
    field: 'structure',
    classes: 'cmd0060-structure',
    headerClasses: 'cmd0060-structure',
  },
  {
    name: 'reg_group_name',
    label: '法規制情報　分類グループ名',
    align: 'left',
    field: (row: Result) => (row.excluded_flag === '1' ? '－' : row.reg_group_name),
    sortable: true,
    style: 'white-space: pre',
  },
  {
    name: 'reg_structure_name',
    label: '法規制情報　物質名',
    align: 'left',
    field: (row: Result) => (row.excluded_flag === '1' ? '－' : row.reg_structure_name),
    sortable: true,
    style: 'white-space: pre',
  },
  {
    name: 'reg_category_name',
    label: '法規制情報　分類名',
    align: 'left',
    field: (row: Result) => (row.excluded_flag === '1' ? '－' : row.reg_category_name),
    sortable: true,
    style: 'white-space: pre',
  },
  {
    name: 'reg_error',
    label: '法規制チェックエラー内容',
    align: 'left',
    field: 'reg_error',
    sortable: true,
  },
  {
    name: 'create_user_name',
    label: '登録者',
    align: 'left',
    field: 'create_user_name',
    sortable: true,
  },
  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: 'create_timestamp',
    style: 'width: 120px',
    sortable: true,
  },
];

// カラムプルダウン開閉
const open = ref(true);

// 検索結果フラグ
const searchResult = ref(false);

const router = useRouter();

// テーブルメッセージ
const tableMessage = ref('検索してください。');

// ダイアログのdisplayFlg(表示判断)
const dialogFlg = ref(false);

// ダイアログのlevel
const dialogLevel = ref('');

// ダイアログのtitle
const dialogTitle = ref('');

// ダイアログのtext
const dialogText = ref(['']);

// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(true);

// 検索条件エラーダイアログフラグ
const isSearchDisplayFlg = ref<boolean>(false);

// 削除完了ダイアログフラグ
const deleteDialogFlg = ref<boolean>(false);

// 検索結果上限超過フラグ
const resultOverFlg = ref<boolean>(false);

// 検索結果要素
const searchResultElement = ref<HTMLImageElement>();

// atto_id
const atto_id = ref('');

// 検索用ATTOID
const searchId = ref('');

// 削除用ATTOID
const delAttoId = ref('');

// 検索用構造式
const searchStructure = ref('');

// 検索条件：法規制チェックエラーのみを表示
const errorOnly = ref(false);

// 検索用法規制チェックエラー
const searchErrorOnly = ref(false);

// 取得したデータ
const data = ref<Array<Result>>([]);

// 出力用データ
const rows = ref<Array<Result>>(data.value);

// ダイアログ閉じる
const closeDialog = () => {
  resultOverFlg.value = false;
  setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
};

/**
 * 削除確認ダイアログ
 *
 * @param id 削除対象のATTOID
 */
const deleteDialog = (id: string) => {
  delAttoId.value = id;
  dialogFlg.value = true;
  dialogConfFlg.value = false;
  dialogTitle.value = '削除確認';
  dialogLevel.value = 'warning';
  dialogText.value = [`${delAttoId.value}を削除します。`, `よろしいですか？`];
};

/**
 * 検索件数超過ダイアログ
 *
 * @param {number} searchNumTotal 最大検索件数
 */
const checkOverResult = (searchNumTotal: number) => {
  if (searchNumTotal > Number(messages.ja.validation.search_max_count)) {
    resultOverFlg.value = true;
    dialogLevel.value = 'warning';
    dialogConfFlg.value = true;
    dialogTitle.value = '検索結果上限値超過';
    dialogText.value = [
      `先頭から${messages.ja.validation.search_max_count}件までの検索結果を表示しています。`,
      'お探しの化合物が見つからない場合、検索条件を絞り込んで再度検索してください。',
    ];
  }
};

// 検索
const searchAttoId = () => {
  dialogFlg.value = false;
  // Loading Start
  Loading.show();
  // バックエンド側にデータを連携
  const formData = new FormData();
  formData.append('atto_id', searchId.value);
  formData.append('structure', searchStructure.value !== undefined ? searchStructure.value : '');
  formData.append('errorOnly', searchErrorOnly.value.toString());

  // 検索実行
  axios
    .post('/cmd006001/searchAttoId', formData)
    .then((response) => {
      switch (response.data.common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          data.value = response.data.attoIdList;
          rows.value = data.value;
          searchResult.value = true;
          checkOverResult(response.data.searchNumTotal);
          tableMessage.value = 'データがありません。';
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (response.data.common.detail_status) {
            // タイムアウトの場合
            case DetailResultStatusCode.STATEMENT_TIMEOUT:
              dialogTitle.value = '検索時間超過エラー';
              dialogText.value = [`検索時間が上限に達しました。条件を見直して再検索してください。`];
              isSearchDisplayFlg.value = true;
              break;
            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        // その他のエラーの場合
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      // スクロール
      setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
    });
};

// 検索ボタン押下時
const pushSearchBtn = () => {
  searchId.value = atto_id.value;
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      dialogFlg.value = true;
      dialogLevel.value = 'error';
      dialogConfFlg.value = true;
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
    }
    searchStructure.value = structure;
    searchErrorOnly.value = errorOnly.value;
    searchAttoId();
  });
};

// 削除
const deleteAttoId = async () => {
  dialogFlg.value = false;
  // Loading Start
  Loading.show();
  // バックエンド側にデータを連携
  const formData = new FormData();
  formData.append('atto_id', delAttoId.value);
  // 削除
  await axios
    .post('/cmd006001/deleteAttoId', formData)
    .then((response) => {
      const { common } = response.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 削除完了ダイアログ表示
          deleteDialogFlg.value = true;
          // 削除完了ダイアログレベル
          dialogLevel.value = 'information';
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '削除完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = [common.message];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              // 削除対象が存在しない場合
              dialogFlg.value = true;
              dialogConfFlg.value = true;
              dialogTitle.value = '削除エラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              break;
            case DetailResultStatusCode.SYSTEM_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        // その他のエラーの場合
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 削除完了ダイアログ押下時
const compDelete = () => {
  deleteDialogFlg.value = false;
  searchAttoId();
};

// 検索条件クリア
const clear = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogFlg.value = true;
      dialogLevel.value = 'error';
      dialogConfFlg.value = true;
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
    }
  });
  atto_id.value = '';
  errorOnly.value = false;
};

// 追加ボタン押下時
const registerData = () => {
  router.push({ name: 'attoIdRegist' });
};

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[10] || (_cache[10] = [
        _createTextVNode("ATTOID一覧")
      ])),
      _: 1
    }),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: _withModifiers(pushSearchBtn, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_expansion_item, {
          modelValue: open.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((open).value = $event)),
          "header-style": "display:none"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_card, {
                style: {"background":"var(--q-lightGray)"},
                flat: "",
                bordered: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _cache[11] || (_cache[11] = _createElementVNode("label", null, "構造式", -1)),
                          _createElementVNode("iframe", _hoisted_5, null, 512)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", null, "ATTO_ID", -1)),
                            _createVNode(_component_q_input, {
                              modelValue: atto_id.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((atto_id).value = $event)),
                              outlined: "",
                              dense: "",
                              maxlength: "12",
                              style: {"background":"var(--q-white)","padding":"0"},
                              class: "input-area",
                              "lazy-rules": "",
                              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_q_checkbox, {
                              modelValue: errorOnly.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((errorOnly).value = $event)),
                              label: "法規制チェックエラーのみを表示",
                              style: {"height":"70px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_q_btn, {
                              color: "primary",
                              style: {"width":"150px"},
                              label: "検索",
                              icon: "mdi-magnify",
                              type: "submit"
                            }),
                            _createVNode(_component_q_btn, {
                              outline: "",
                              style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                              icon: "mdi-eraser",
                              label: "クリア",
                              onClick: clear
                            })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(SearchOpenCloseButton, {
      display: searchResult.value,
      open: open.value,
      style: {"margin-bottom":"20px"},
      onOpen: _cache[4] || (_cache[4] = ($event: any) => (open.value = $event))
    }, null, 8, ["display", "open"]),
    _createElementVNode("div", {
      ref_key: "searchResultElement",
      ref: searchResultElement,
      class: "cmd0060-result-table"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (rows.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: rows.value,
          columns: columns,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "no-data-label": tableMessage.value,
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_btn, {
                icon: "mdi-plus",
                label: "追加",
                class: "add-btn",
                color: "primary",
                onClick: registerData
              })
            ])
          ]),
          "header-cell-delete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area" })
          ]),
          "body-cell-delete": _withCtx((cell) => [
            _createVNode(_component_q_td, { class: "table-btn-area" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_btn, {
                    icon: "mdi-close",
                    label: "削除",
                    color: "primary",
                    class: "deletebtn",
                    outline: "",
                    style: {"color":"var(--q-delete)"},
                    onClick: ($event: any) => (deleteDialog(cell.row.atto_id))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-structure": _withCtx((structure) => [
            _createVNode(_component_q_td, { style: {"padding":"2px","min-width":"180px","max-width":"180px","width":"180px","min-height":"180px"} }, {
              default: _withCtx(() => [
                _createVNode(AtomImage, {
                  exatoms: structure.row.structure
                }, null, 8, ["exatoms"])
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell": _withCtx((cell) => [
            _createVNode(_component_q_td, { props: cell }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(cell.value), 1)
                ])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "no-data-label", "pagination-label"])
      ], 2)
    ], 512),
    _createVNode(AlertDialog, {
      display: isSearchDisplayFlg.value,
      level: "error",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[5] || (_cache[5] = ($event: any) => (isSearchDisplayFlg.value = false))
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: dialogFlg.value,
      level: dialogLevel.value,
      confirmation: dialogConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onConfirm: deleteAttoId,
      onComplete: _cache[6] || (_cache[6] = ($event: any) => (dialogFlg.value = false)),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (dialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: deleteDialogFlg.value,
      level: dialogLevel.value,
      confirmation: dialogConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: compDelete,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (deleteDialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: resultOverFlg.value,
      level: "warning",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: closeDialog,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (resultOverFlg.value = false))
    }, null, 8, ["display", "title", "text"])
  ]))
}
}

})